import { Action } from '@ngrx/store';

export enum AppStateActionTypes {
  INIT_APP_STATE = '[App State] Init App State',

  SET_SEARCH_TYPE = '[App State] Set Search Type',

  SET_APP_STATE = '[App State] Set App State',
  SET_MAP_REDRAW_TRIGGER = '[App State] Set Map Redraw Trigger'
}

export class InitAppStateAction implements Action {
  readonly type = AppStateActionTypes.INIT_APP_STATE;
  constructor(public payload?: any) {}
}

export class SetSearchTypeAction implements Action {
  readonly type = AppStateActionTypes.SET_SEARCH_TYPE;
  constructor(public payload: any) {}
}

export class SetAppStateAction implements Action {
  readonly type = AppStateActionTypes.SET_APP_STATE;
  constructor(public payload?: any) {}
}

export class SetMapRedrawTriggerAction implements Action {
  readonly type = AppStateActionTypes.SET_MAP_REDRAW_TRIGGER;
  constructor(public payload?: string) {}
}
export type AppStateActions =
  | InitAppStateAction
  | SetSearchTypeAction
  | SetAppStateAction
  | SetMapRedrawTriggerAction;
